export enum prospectTypeEnum {
	ACCOUNT = 'account',
	CONTACT = 'contact'
}